Number.prototype.between = function(a, b) {
    return this >= Math.min.apply(Math, [a, b]) && this <= Math.max.apply(Math, [a, b]);
};
